import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRightIcon, FacebookIcon, LinkIcon, TwitterIcon } from 'lucide-react';
import { PageHero } from '../components/layout/PageHero';
import { CtaBand } from '../components/ui/CtaBand';
import { NotFound } from './NotFound';
import { articles, getArticle } from '../data/articles';
export function NewsArticle() {
  const {
    slug = ''
  } = useParams();
  const article = getArticle(slug);
  if (!article) {
    return <NotFound data-id="element-1151" data-mp="e3ojkyidybrr" />;
  }
  const related = articles.filter(item => item.slug !== article.slug).slice(0, 3);
  return <>
      <PageHero eyebrow={article.category} title={article.title} intro={article.standfirst} crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'News',
      to: '/news'
    }, {
      label: article.category
    }]} meta={<p className="text-[14px] text-white/60" data-id="element-1153" data-mp="23g9tvhcjua4p">
            {article.date} · {article.author}
          </p>} data-id="element-1152" data-mp="nz009mdctt25" />

      <article className="bg-sand-50 py-14 lg:py-20" data-id="element-1154" data-mp="2896s5mqlzjjh">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1155" data-mp="286kjtkvw9007">
          <div className="overflow-hidden rounded-media" data-id="element-1156" data-mp="23adcbnnungg5">
            <img src={article.image} alt="" className="aspect-[21/9] w-full object-cover" data-id="element-1157" data-mp="1ya7q4n0cmm5g" />
          </div>

          <div className="mt-12 grid gap-12 lg:grid-cols-12" data-id="element-1158" data-mp="1ub8cme0jxh2e">
            <div className="lg:col-span-8" data-id="element-1159" data-mp="1paufvs4ehtjo">
              <div className="space-y-6" data-id="element-1160" data-mp="1pbvu25gpqw5m">
                {article.body.map((paragraph, index) => <React.Fragment key={paragraph.slice(0, 24)} data-id="element-1161" data-mp="1fk97xe2u7co3" data-mpi={index}>
                    <p className="text-[18px] leading-[1.75] text-slate-700" data-id="element-1162" data-mp="1fksoorgr3v0j">{paragraph}</p>
                    {article.pullQuote && index === 1 && <blockquote className="border-l-2 border-green-600 py-2 pl-6" data-id="element-1163" data-mp="16k2yc3a9ewu7">
                        <p className="font-display text-[24px] leading-snug text-ink" data-id="element-1164" data-mp="11khx1m7maceb">
                          “{article.pullQuote}”
                        </p>
                      </blockquote>}
                  </React.Fragment>)}
              </div>

              <div className="mt-10 flex flex-wrap items-center gap-3 border-t border-sand-300 pt-8" data-id="element-1165" data-mp="vw4rnwdfxf54">
                <span className="text-[13px] font-semibold text-slate-500" data-id="element-1166" data-mp="mxrobzrkdhip">Share</span>
                {[{
                label: 'Share on X',
                Icon: TwitterIcon
              }, {
                label: 'Share on Facebook',
                Icon: FacebookIcon
              }, {
                label: 'Copy link',
                Icon: LinkIcon
              }].map(({
                label,
                Icon
              }) => <button key={label} type="button" aria-label={label} className="flex h-10 w-10 items-center justify-center rounded-lg border border-sand-300 text-slate-600 transition-colors duration-150 ease-emphasis hover:border-green-600 hover:text-green-700" data-id="element-1167" data-mp="10wj0vhqs2v4q">
                    <Icon aria-hidden className="h-[18px] w-[18px]" data-id="element-1168" data-mp="3j33k3jsi0yuw" />
                  </button>)}
              </div>
            </div>

            <aside className="lg:col-span-4" data-id="element-1169" data-mp="3e3qxn05jhtsu">
              <div className="rounded-media border border-sand-200 bg-white p-6 lg:sticky lg:top-28" data-id="element-1170" data-mp="3rvfax6riyobe">
                <h2 className="text-[12px] font-bold uppercase tracking-[0.12em] text-slate-500" data-id="element-1171" data-mp="3nubx0pt1f2ct">
                  Tags
                </h2>
                <ul className="mt-3 flex flex-wrap gap-2" data-id="element-1172" data-mp="305akorh33729">
                  {article.tags.map(tag => <li key={tag} className="rounded border border-sand-300 bg-sand-50 px-2.5 py-1 text-[13px] text-slate-600" data-id="element-1173" data-mp="2v6zaugqsgwk1">
                      {tag}
                    </li>)}
                </ul>

                <h2 className="mt-8 text-[12px] font-bold uppercase tracking-[0.12em] text-slate-500" data-id="element-1174" data-mp="odn9l1ri0s0j">
                  Supporting documents
                </h2>
                <ul className="mt-3 space-y-2 text-[14px]" data-id="element-1175" data-mp="1eqjyrh6mduad">
                  <li data-id="element-1176" data-mp="1es4uha4o7j9t">
                    <Link to="/manifesto" className="text-green-700 hover:text-green-800" data-id="element-1177" data-mp="1jp4wn9yeg1vn">
                      Full manifesto (PDF)
                    </Link>
                  </li>
                  <li data-id="element-1178" data-mp="1oqkmdfbiuwkd">
                    <Link to="/media" className="text-green-700 hover:text-green-800" data-id="element-1179" data-mp="1tn1bocugjgz1">
                      Media centre and official portraits
                    </Link>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </article>

      <section className="bg-white py-14 lg:py-20" aria-labelledby="related-news-heading" data-id="element-1180" data-mp="27ezd01hxg8kn">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1181" data-mp="2cdsnrm5txlh4">
          <h2 id="related-news-heading" className="font-display text-[26px] text-ink" data-id="element-1182" data-mp="2cd0x8pr3adxp">
            Related updates
          </h2>
          <ul className="mt-8 grid gap-6 md:grid-cols-3" data-id="element-1183" data-mp="2le7dqytqnoqy">
            {related.map(item => <li key={item.slug} data-id="element-1184" data-mp="9r55haytdhpy">
                <Link to={`/news/${item.slug}`} className="group flex h-full flex-col rounded-card border border-sand-200 p-5 transition-colors duration-200 ease-emphasis hover:border-green-200 hover:bg-sand-50" data-id="element-1185" data-mp="9s6ihkze4eab">
                  <span className="text-[11px] font-bold uppercase tracking-[0.1em] text-green-700" data-id="element-1186" data-mp="3rx03tzuwnfdh">
                    {item.category} · {item.date}
                  </span>
                  <span className="mt-2 font-display text-[18px] leading-snug text-ink" data-id="element-1187" data-mp="tgxhfll82gvz">
                    {item.title}
                  </span>
                  <span className="mt-auto inline-flex items-center gap-2 pt-5 text-[13px] font-semibold text-green-700" data-id="element-1188" data-mp="jojggv1yxeav">
                    Read more
                    <ArrowRightIcon aria-hidden className="h-3.5 w-3.5 transition-transform duration-200 ease-emphasis group-hover:translate-x-1" data-id="element-1189" data-mp="eodrxnqzw7x0" />
                  </span>
                </Link>
              </li>)}
          </ul>
        </div>
      </section>

      <CtaBand title="Never miss a statement." description="Campaign updates by WhatsApp or email, with the full text of every statement." primary={{
      label: 'Join campaign updates',
      to: '/join'
    }} secondary={{
      label: 'Back to the newsroom',
      to: '/news'
    }} data-id="element-1190" data-mp="35oum08gfk1na" />
    </>;
}